(() => {
  if (customElements.get("pa-trust-module")) {
    return;
  }

  class PaTrustModule extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.drawer = this.querySelector("[data-pa-trust-drawer]");
      this.sheet = this.querySelector("[data-pa-trust-sheet]");
      this.addEventListener("click", this.handleClick);
      this.drawer?.addEventListener("openable-element:close", this.handleClose);
      this.sheet?.addEventListener("openable-element:close", this.handleClose);

      if (window.Shopify?.designMode) {
        document.addEventListener("shopify:block:select", this.handleBlockSelect);
      }
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.drawer?.removeEventListener("openable-element:close", this.handleClose);
      this.sheet?.removeEventListener("openable-element:close", this.handleClose);
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
    }

    handleClick(event) {
      const trigger = event.target.closest("[data-pa-trust-trigger]");
      if (!trigger || !this.contains(trigger)) {
        return;
      }

      this.openItem(trigger);
    }

    handleBlockSelect(event) {
      const item = event.target.closest?.("[data-pa-trust-item]");
      const trigger = item?.querySelector("[data-pa-trust-trigger]");
      if (trigger && this.contains(trigger)) {
        this.openItem(trigger);
      }
    }

    openItem(trigger) {
      const itemId = trigger.dataset.paTrustId;
      const template = this.querySelector(`template[data-pa-trust-template="${itemId}"]`);
      const useSheet = window.matchMedia("(max-width: 740px)").matches;
      const surface = useSheet ? this.sheet : this.drawer;
      const otherSurface = useSheet ? this.drawer : this.sheet;
      const target = surface?.querySelector("[data-pa-trust-content]");

      if (!template || !surface || !target) {
        return;
      }

      if (otherSurface) {
        otherSurface.open = false;
      }

      target.replaceChildren(template.content.cloneNode(true));
      this.querySelectorAll("[data-pa-trust-trigger]").forEach((item) => {
        item.setAttribute("aria-expanded", "false");
        item.removeAttribute("aria-controls");
      });

      trigger.setAttribute("aria-expanded", "true");
      trigger.setAttribute("aria-controls", surface.id);
      surface.setAttribute("aria-label", trigger.dataset.paTrustTitle || "Shopping information");
      this.activeTrigger = trigger;
      surface.open = true;
    }

    handleClose() {
      if (!this.drawer?.open && !this.sheet?.open && this.activeTrigger) {
        const trigger = this.activeTrigger;
        trigger.setAttribute("aria-expanded", "false");
        trigger.removeAttribute("aria-controls");
        this.activeTrigger = null;

        if (document.contains(trigger)) {
          trigger.focus({ preventScroll: true });
        }
      }
    }
  }

  customElements.define("pa-trust-module", PaTrustModule);
})();
